import {
  CLEAR_WATCHERS
} from '@/store/mutation-types'
import { firebaseAction } from 'vuexfire'
import l from '@/vendor/logger'
import { db } from '@/store'

const state = {
  watchers: null
}

const getters = {
  totalWatchers (state) {
    return state.watchers
      ? Object.keys(state.watchers).length
      : ''
  }
}

const mutations = {
  [CLEAR_WATCHERS] (state, key) {
    state.watchers = null
  }
}

const actions = {
  bindWatchers: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('watchers', db.ref(`watchers/${rootState.rid}`))
  }),

  unbindWatchers: firebaseAction(({ unbindFirebaseRef, rootState, commit }) => {
    unbindFirebaseRef('watchers')
    db.ref(`watchers/${rootState.rid}`).off()
    commit(CLEAR_WATCHERS)
  }),

  async setWatcher ({ commit, state, rootState }, { uid, displayName, photoURL }) {
    l.d('room/setWatcher', displayName)
    try {
      await db.ref(`watchers/${rootState.rid}/${uid}`).set({
        uid,
        displayName,
        photoURL
      })
    } catch (err) {
      l.e('room/setWatcher', err)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
